import { Platform } from 'react-native';

import { PERMISSIONS, request } from 'react-native-permissions';

export const requestTrackingPermission = async () => {
    if (Platform.OS === 'ios') {
        try {
            return await request(PERMISSIONS.IOS.APP_TRACKING_TRANSPARENCY);
        } catch (error) {
            console.error('Request ATT error: ', error);
            return Promise.resolve('unavailable');
        }
    }

    return Promise.resolve('granted');
};
